var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromeExtensionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 13.808,
    height: 12.072,
    fill: "#949494"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chrome_store",
    "data-name": "Chrome store",
    transform: "translate(-956 -609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3140",
    "data-name": "Group 3140",
    transform: "translate(956 610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3139",
    "data-name": "Group 3139",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M6.9,8.708a2.464,2.464,0,0,0-2.275,3.364h4.55A2.464,2.464,0,0,0,6.9,8.708m0-3.054A5.49,5.49,0,0,0,2.412,8.011l1.515,2.805A3.008,3.008,0,0,1,6.9,8.151h4.583A5.469,5.469,0,0,0,6.9,5.654m4.9,3.053H8.636a3.031,3.031,0,0,1,1.129,3.364h2.544a5.543,5.543,0,0,0-.5-3.364M2.077,8.556a5.553,5.553,0,0,0-.652,2.614,5.488,5.488,0,0,0,.074.9H3.976ZM13.807,0H0V11.124a.946.946,0,0,0,.942.948H.958A6.043,6.043,0,0,1,6.9,5.117a6.057,6.057,0,0,1,5.945,6.954h.018a.946.946,0,0,0,.942-.948V0ZM8.914,2.407a.624.624,0,0,1-.444.186H5.337a.629.629,0,0,1-.627-.609.629.629,0,0,1,.626-.609H8.47a.629.629,0,0,1,.627.608.634.634,0,0,1-.183.424",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 14,
    height: 14,
    transform: "translate(956 609)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeExtensionIcon);
export default __webpack_public_path__ + "static/media/chrome-extension-icon.a8a82a3ab9a85f7923743e50898a8e11.svg";
export { ForwardRef as ReactComponent };